module.exports = __webpack_public_path__ + "img/CH-288.104b60ce.jpg";